export default (el) => {
	const rect = el.getBoundingClientRect()
	return {
		x: rect.left + window.scrollX,
		y: rect.top + window.scrollY,
	}
}
